import { navigate, PageProps } from 'gatsby'
import clsx from 'clsx'
import {
  Card,
  Divider,
  Form,
  Input,
  Label,
  SEO,
  Title,
} from 'components/common'
import Layout from 'components/layouts/tow-column'

const onBack = () => navigate('../')

export const Head = () => <SEO title="スタッフアカウントの追加" />

const IndexPage = (props: PageProps<Queries.Query>): JSX.Element => {
  return (
    <>
      <Layout title="スタッフアカウントを追加する" onBack={onBack}>
        <Divider space="medium" />

        <div className={clsx('w-2/6')}>
          <Layout.Section size="large">
            <Layout.Item>
              <Title level={4} style={{ paddingTop: '24px' }}>
                スタッフアカウント
              </Title>
              <p className={clsx('w-5/6', 'mt-4')}>
                彼らに招待状を送ってあなたのストアへの
                アクセス権を与えます。デザイナー、マーケ
                ティング担当者と仕事をしている場合は、
                コラボレーターがアクセスできるようにするを 確認してください。
              </p>
            </Layout.Item>
          </Layout.Section>
        </div>

        <Layout.Section size="small">
          <Layout.Item>
            <Card shadow>
              <Form component="form" name="accounts">
                <div className={clsx('flex', 'w-full')}>
                  <Form.Item style={{ width: '48%', marginRight: '4%' }}>
                    <Label>姓</Label>
                    <Input />
                  </Form.Item>
                  <Form.Item style={{ width: '48%' }}>
                    <Label>名</Label>
                    <Input />
                  </Form.Item>
                </div>
                <Form.Item style={{ width: '100%' }}>
                  <Label>メールアドレス</Label>
                  <Input />
                </Form.Item>
              </Form>
            </Card>

            {/*<Card>*/}
            {/*  <Button type="primary">*/}
            {/*    すべてを選択する*/}
            {/*  </Button>*/}
            {/*  <div className={clsx('flex', 'w-full', 'mt-8')}>*/}
            {/*    <div style={{ width: '48%', marginRight: '4%' }}>*/}
            {/*      <p>一般</p>*/}
            {/*      <Form.Item className={clsx('mb-0')}>*/}
            {/*        <Checkbox>予約作成</Checkbox>*/}
            {/*      </Form.Item>*/}
            {/*      <Form.Item className={clsx('mb-0')}>*/}
            {/*        <Checkbox>お知らせ作成</Checkbox>*/}
            {/*      </Form.Item>*/}
            {/*      <Form.Item className={clsx('mb-0')}>*/}
            {/*        <Checkbox>分析閲覧</Checkbox>*/}
            {/*      </Form.Item>*/}
            {/*    </div>*/}
            {/*    <div style={{ width: '48%' }}>*/}
            {/*      <p>管理</p>*/}
            {/*      <Form.Item className={clsx('mb-0')}>*/}
            {/*        <Checkbox>アカウント管理</Checkbox>*/}
            {/*      </Form.Item>*/}
            {/*      <Form.Item className={clsx('mb-0')}>*/}
            {/*        <Checkbox>顧客管理</Checkbox>*/}
            {/*      </Form.Item>*/}
            {/*      <Form.Item className={clsx('mb-0')}>*/}
            {/*        <Checkbox>施設管理</Checkbox>*/}
            {/*      </Form.Item>*/}
            {/*      <Form.Item className={clsx('mb-0')}>*/}
            {/*        <Checkbox>料金テーブル管理</Checkbox>*/}
            {/*      </Form.Item>*/}
            {/*      <Form.Item className={clsx('mb-0')}>*/}
            {/*        <Checkbox>予約管理</Checkbox>*/}
            {/*      </Form.Item>*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*</Card>*/}
          </Layout.Item>
        </Layout.Section>
      </Layout>
    </>
  )
}

export default IndexPage
